<template lang="pug">
  div.group-operations.recalcs
    e-toolbar(
    :items="items"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"
    :hideAddButton="true"
    :hideSearch="true"

      :useFilterBtn="true"
      :showFilter="showFilter"
      @closeFilterPanel="onCloseFilterPanel()"
      @openFilterPanel="onOpenFilterPanel()"
    )
      e-form-search-filter(
        slot="filter"
        :formValidator="formValidator"
        v-if="showFilter"
        @apply="applyFilter()"
        @reset="resetFilter()"
      )
        div.one-row
          e-form-group(
            formGroupStyle="filter-block"
            label="Период"
            inputType="calendar-range"
            :model="filterModel"
            tabView="tab1"
            name="start"
            toName="end"
            :valueFormat="CALENDAR.valueFormat"
            :format="CALENDAR.format"
            type="date"
          )

          e-form-group(
            formGroupStyle="filter-block"
            label="Основание"
            :model="filterModel"
            tabView="tab1"
            name="comment"
          )

          e-form-search-filter-buttons(
            :loading="searchInProgress"
          ).filter-block

      div(slot="additionalActions")
        e-button-edit(
        @click="openCalcUpdate()"
        label="Перерасчет"
        )

    e-table(
    :defaultColumnWidth="150"
    :items="items"
    :showCheckbox="false"
    :showDeleteButton="false"
    :showEditButton="false"
    )

    router-view
</template>

<script>
  import {groupOperations} from "../../api/api-endpoints"
  import tableMixin from "../../components/table/table-mixin.js"
  import {CALENDAR} from "../../config/config"

  const FilterModel = () => ({
    start: '',
    end: '',
    comment: ''
  })

  export default {
    mixins: [tableMixin],
    data () {
      return {
        filterModel: new FilterModel()
      }
    },
    computed: {
      CALENDAR () {
        return CALENDAR
      }
    },
    methods: {
      getEndpoint(route) {
        return groupOperations.calcIndividuals(route)
      },
      openCalcUpdate() {
        this.$router.push({
          name: `${this.$route.name}.update`,
          query: {
            prevRoute: this.getRoute().json
          }
        })
      }
    }
  }
</script>
